'use strict';

module.exports = {
  showMore: function showMore() {
    $('.container').on('click', '.show-more-blogs button', function (e) {
      e.stopPropagation();
      var showMoreUrl = $(this).data('url');
      e.preventDefault();
      $.spinner().start();
      $.ajax({
        url: showMoreUrl,
        data: {
          selectedUrl: showMoreUrl
        },
        method: 'GET',
        success: function success(response) {
          $('.blog-grid-footer').replaceWith(response);
          $.spinner().stop();
        },
        error: function error() {
          $.spinner().stop();
        }
      });
    });
  }
};